export const POST_DEFAULT_PAGE = 1;
export const POST_DEFAULT_PAGE_SIZE = 12;

export const POST_ENDPOINTS = {
  // 1. List Posts / Leads (General View)
  listGeneral: "/property/leads",

  // 2. List Posts with Filters / Preferred (Partner View)
  listPreferred: "/post/list/preferred",

  // 3. List My / User's Specific Posts
  listMy: "/property/lead/myLead",

  // 4. Get Post Details by ID
  details: (id) => `/property/lead/${id}`,

  // 5. Add / Create Post
  create: "/property/lead/create",

  // 6. Delete Post
  remove: (id) => `/property/lead/delete/${id}`,

  // 7. Comments & Inquiries on a Post
  comments: (userId, leadId) =>
    `/property/requestLeadComments/${userId}/${leadId}`,

  // 8. Add Comment / Reply to a Post
  addComment: "/property/addRequestLeadComment",

  // 9. Edit Post Comment
  editComment: "/property/editRequestLeadComment",

  // 10. Delete Post Comment
  deleteComment: (commentId) =>
    `/property/deleteRequestLeadComment/${commentId}`,

  // Helper metadata endpoints
  states: (countryId = 1) => `/admin/states/${countryId}`,
  cities: (stateId) => `/admin/cities/${stateId}`,
  propertyTypes: "/all/property/types",
  allServices: "/all/services",
};

export const POST_TABS = {
  ALL: "all",
  PREFERRED: "preferred",
  MY: "my",
};
